import React from 'react'
import { useNavigate } from 'react-router-dom'

const AboutPage = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center p-4 crt-container">
      <div className="max-w-4xl w-full crt-screen">
        {/* Header */}
        <div className="text-center mb-8">
          <button
            onClick={() => navigate('/lobby')}
            className="btn-retro btn-secondary mb-6"
          >
            ← Back to Purgatory
          </button>
          <h1 className="text-4xl md:text-6xl font-bold text-neon-green mb-4">
            About Common Ground
          </h1>
          <p className="text-purgatory-mist font-mono text-lg">
            Building bridges between souls through shared values
          </p>
        </div>

        {/* Mission Section */}
        <div className="card-retro p-8 mb-8">
          <h2 className="text-2xl font-bold text-purgatory-gold mb-4">
            🌍 Our Mission
          </h2>
          <p className="text-purgatory-mist mb-4 leading-relaxed">
            In a world increasingly divided by differences, Common Ground creates spaces for meaningful connection. 
            We believe that by focusing on shared values rather than differences, we can build bridges between 
            people and foster understanding across divides.
          </p>
          <p className="text-purgatory-mist leading-relaxed">
            Our platform uses carefully crafted questions to help people discover their common ground with 
            strangers, creating opportunities for authentic dialogue and connection.
          </p>
        </div>

        {/* How It Works */}
        <div className="card-retro p-8 mb-8">
          <h2 className="text-2xl font-bold text-purgatory-gold mb-4">
            🔄 How It Works
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl mb-3">🎯</div>
              <h3 className="text-purgatory-gold font-semibold mb-2">Find Common Ground</h3>
              <p className="text-purgatory-mist text-sm">
                Answer three rounds of questions designed to reveal your values and beliefs
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-3">💬</div>
              <h3 className="text-purgatory-gold font-semibold mb-2">Connect & Chat</h3>
              <p className="text-purgatory-mist text-sm">
                Chat anonymously with someone who shares your values to explore deeper connections
              </p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-3">🌉</div>
              <h3 className="text-purgatory-gold font-semibold mb-2">Build Bridges</h3>
              <p className="text-purgatory-mist text-sm">
                Discover that despite differences, we all share fundamental human values
              </p>
            </div>
          </div>
        </div>

        {/* Why It Matters */}
        <div className="card-retro p-8 mb-8">
          <h2 className="text-2xl font-bold text-purgatory-gold mb-4">
            💡 Why This Matters
          </h2>
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="text-purgatory-gold text-xl">•</div>
              <p className="text-purgatory-mist">
                <strong>Reduces Polarization:</strong> By focusing on shared values, we break down the "us vs them" mentality
              </p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="text-purgatory-gold text-xl">•</div>
              <p className="text-purgatory-mist">
                <strong>Builds Empathy:</strong> Anonymous conversations help people see beyond surface differences
              </p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="text-purgatory-gold text-xl">•</div>
              <p className="text-purgatory-mist">
                <strong>Creates Understanding:</strong> Shared experiences and values form the foundation for meaningful relationships
              </p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="text-purgatory-gold text-xl">•</div>
              <p className="text-purgatory-mist">
                <strong>Fosters Hope:</strong> Shows that connection is possible even in our divided world
              </p>
            </div>
          </div>
        </div>

        {/* Support Section */}
        <div className="card-retro p-8 border-purgatory-gold border-opacity-50 bg-purgatory-gold bg-opacity-5">
          <div className="text-center">
            <div className="text-3xl mb-3">🌍</div>
            <h2 className="text-purgatory-gold font-bold mb-3 text-2xl">
              Support Our Mission
            </h2>
            <p className="text-purgatory-mist mb-6 leading-relaxed">
              Your support helps us reach more people, develop better questions, and create 
              more opportunities for meaningful connection. Together, we can build a more 
              connected and understanding world.
            </p>
            <div className="space-y-4">
              <a 
                href="https://checkout.revolut.com/pay/4b87e61e-9c30-43a3-8822-9877bed4fe24"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-purgatory-gold text-purgatory-dark px-8 py-4 font-bold text-lg hover:bg-purgatory-gold hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                🚀 FUND THE MISSION
              </a>
              <p className="text-purgatory-mist text-sm">
                Every contribution helps us unite more souls and shape a better future
              </p>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/lobby')}
            className="btn-retro btn-secondary px-8 py-3"
          >
            Return to Purgatory
          </button>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
